export const BALL_WIDTH = 48;

export const BALL_TENSION = 300;
export const BALL_FRICTION = 10;
export const BALL_SHAKE_AMPLITUDE = 8;
export const BALL_SHAKE_FREQUENCY = 4;
export const BALL_SHAKE_DURATION = 1000;

export const BALL_POP_STARTING_SCALE = 1;
export const BALL_POP_STARTING_OPACITY = 1;
export const BALL_POP_PULSE_SCALES = [1.5, 1];
export const BALL_POP_PULSE_DURATION = 500;
export const BALL_POP_PULSE_TOTAL_PULSES = 3.25;

export const BALL_APPEAR_STARTING_SCALE = 0.5;
export const BALL_APPEAR_STARTING_OPACITY = 0;
export const BALL_APPEAR_PULSE_SCALES = [1, 0.75];
export const BALL_APPEAR_PULSE_DURATION = 400;
export const BALL_APPEAR_PULSE_TOTAL_PULSES = 3;

export const BALL_ANIMATION_DEFAULT_DURATION_SECONDS = 2.5;
export const BALL_ANIMATION_DEFAULT_DURATION_MS = BALL_ANIMATION_DEFAULT_DURATION_SECONDS * 1000;
export const BALL_ANIMATION_DEFAULT_TO_X_POSITION = 100;

export enum BallIcon {
  Microphone = 'microphone',
  Hourglass = 'hourglass',
}

export enum BallColor {
  Active = 'active',
  Inactive = 'inactive',
}
